(function () {
  const ROOT_SELECTOR = '[data-rs-ingredients-grid]';
  const DRAWER_SELECTOR = '[data-rs-ingredient-drawer]';
  const TRIGGER_SELECTOR = '[data-rs-ingredient-trigger]';
  const PANEL_SELECTOR = '[data-rs-ingredient-panel]';
  const CLOSE_SELECTOR = '[data-rs-ingredient-close]';
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter((element) => {
      return !element.hasAttribute('hidden') && element.offsetParent !== null;
    });
  }

  function initIngredientGrid(root) {
    if (!root || root.dataset.rsIngredientsReady === 'true') return;

    const drawer = root.querySelector(DRAWER_SELECTOR);
    const dialog = drawer ? drawer.querySelector('.rs-ingredient-drawer__dialog') : null;
    const triggers = Array.from(root.querySelectorAll(TRIGGER_SELECTOR));
    const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR));
    let activeTrigger = null;

    if (!drawer || !dialog || !triggers.length || !panels.length) return;

    root.dataset.rsIngredientsReady = 'true';

    function closePanels() {
      panels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
    }

    function setExpanded(activeElement) {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', trigger === activeElement ? 'true' : 'false');
      });
    }

    function openDrawer(blockId, trigger) {
      const targetPanel = panels.find((panel) => panel.getAttribute('data-rs-ingredient-panel') === blockId);
      if (!targetPanel) return;

      closePanels();
      targetPanel.hidden = false;
      targetPanel.classList.add('is-active');
      targetPanel.setAttribute('aria-hidden', 'false');

      const panelTitle = targetPanel.querySelector('.rs-ingredient-drawer__title');
      if (panelTitle && panelTitle.id) {
        dialog.setAttribute('aria-labelledby', panelTitle.id);
        dialog.removeAttribute('aria-label');
      }

      activeTrigger = trigger || activeTrigger;
      setExpanded(activeTrigger);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('rs-ingredients-drawer-open');

      window.requestAnimationFrame(() => {
        const closeButton = dialog.querySelector(CLOSE_SELECTOR);
        (closeButton || dialog).focus();
      });
    }

    function closeDrawer(options) {
      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('rs-ingredients-drawer-open');
      setExpanded(null);

      if (!options || options.restoreFocus !== false) {
        const focusTarget = activeTrigger;
        if (focusTarget && document.contains(focusTarget)) {
          focusTarget.focus();
        }
      }

      activeTrigger = null;
    }

    function handleClick(event) {
      const trigger = event.target.closest(TRIGGER_SELECTOR);
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        openDrawer(trigger.getAttribute('data-rs-ingredient-trigger'), trigger);
        return;
      }

      if (event.target.closest(CLOSE_SELECTOR)) {
        event.preventDefault();
        closeDrawer();
      }
    }

    function handleKeydown(event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements(dialog);
      if (!focusableElements.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }

    function handleBlockSelect(event) {
      const blockId = event.detail && event.detail.blockId;
      if (!blockId || !root.contains(event.target)) return;

      const trigger = root.querySelector(`[data-rs-ingredient-trigger="${blockId}"]`);
      if (trigger) {
        openDrawer(blockId, trigger);
      }
    }

    function handleBlockDeselect(event) {
      if (root.contains(event.target)) {
        closeDrawer({ restoreFocus: false });
      }
    }

    root.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('shopify:block:select', handleBlockSelect);
    document.addEventListener('shopify:block:deselect', handleBlockDeselect);

    root.rsIngredientsDestroy = function () {
      root.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('shopify:block:select', handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', handleBlockDeselect);
      document.body.classList.remove('rs-ingredients-drawer-open');
      delete root.dataset.rsIngredientsReady;
    };
  }

  function initAllIngredientGrids(container) {
    (container || document).querySelectorAll(ROOT_SELECTOR).forEach(initIngredientGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllIngredientGrids(document));
  } else {
    initAllIngredientGrids(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllIngredientGrids(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (typeof root.rsIngredientsDestroy === 'function') {
        root.rsIngredientsDestroy();
      }
    });
  });
})();
